import React, { useEffect, useState } from 'react'
import styled from 'styled-components'

import PlanSelection from 'pages/paywall/PlanSelection'

import { color } from 'styles/colors'

type Props = {
  selectedInput: PlanSelection
  onChangeSelection: (value: PlanSelection) => void
}

const PremiumSelection = ({ selectedInput, onChangeSelection }: Props) => {
  const [selectedPlan, setSelectedPlan] = useState(selectedInput || PlanSelection.YEARLY)

  useEffect(() => {
    setSelectedPlan(selectedInput)
  }, [selectedInput])

  const onChange = (value) => {
    setSelectedPlan(Number(value))
    onChangeSelection(value)
  }

  return (
    <S.Container>
      <S.PaymentOption>
        <S.TopColorAccent checked={selectedPlan === PlanSelection.YEARLY}>
          <S.SaveText>Save 20%</S.SaveText>
          <div>Annual Plan</div>
          <S.EmptyDiv />
        </S.TopColorAccent>

        <S.PriceSelection
          checked={selectedPlan === PlanSelection.YEARLY}
          box={0}
          onClick={() => onChange(PlanSelection.YEARLY)}
        >
          <S.PriceInfo>
            <S.PricePerMonth checked={selectedPlan === PlanSelection.YEARLY}>
              USD $200/month
            </S.PricePerMonth>
            <S.Description>Billed annually</S.Description>
          </S.PriceInfo>

          <S.RadioButton>
            <S.Input
              value={0}
              type="radio"
              checked={selectedInput === PlanSelection.YEARLY}
              onChange={() => onChange(PlanSelection.YEARLY)}
              aria-label="Select yearly plan"
            />

            <S.SelectLabel checked={selectedPlan === PlanSelection.YEARLY}>
              Select
            </S.SelectLabel>
          </S.RadioButton>
        </S.PriceSelection>
      </S.PaymentOption>

      <S.PaymentOption>
        <S.TopColorAccent checked={selectedPlan === PlanSelection.MONTHLY}>
          <div>Monthly Plan</div>
        </S.TopColorAccent>

        <S.PriceSelection
          checked={selectedPlan === PlanSelection.MONTHLY}
          box={1}
          onClick={() => onChange(PlanSelection.MONTHLY)}
        >
          <S.PriceInfo>
            <S.PricePerMonth checked={selectedPlan === PlanSelection.MONTHLY}>
              USD $250/month
            </S.PricePerMonth>
            <S.Description >No commitment</S.Description>
          </S.PriceInfo>

          <S.RadioButton>
            <S.Input
              value={1}
              type="radio"
              checked={selectedInput === PlanSelection.MONTHLY}
              onChange={() => onChange(PlanSelection.MONTHLY)}
              aria-label="Select monthly plan"
            />

            <S.SelectLabel checked={selectedPlan === PlanSelection.MONTHLY}>
              Select
            </S.SelectLabel>
          </S.RadioButton>
        </S.PriceSelection>
      </S.PaymentOption>
    </S.Container>
  )
}

export default PremiumSelection

const S = {
  Container: styled.div`
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    width: 100%;
    text-transform: uppercase;
    font-size: 18px;
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
  `,
  TopColorAccent: styled.div<{ checked?: boolean }>`
    display: flex;
    justify-content: space-around;
    padding: 2px 0;
    font-size: x-small;
    font-weight: bold;
    text-transform: none;
    ${({ checked }) => checked
    ? 'background-color: #b1c6d7;' : 'background-color: #F4F4F4;'}
  `,
  SaveText: styled.div`
    margin-left: 15px;
    color: ${color('errorText')};
  `,
  EmptyDiv: styled.div`
    width: 75px;
  `,
  PaymentOption: styled.div`
    width: 100%;
  `,
  PriceSelection: styled.div<{ checked: boolean, box: number }>`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    padding: 10px;
    ${({ checked }) => checked
    ? 'background-color: #C5D8E6;' : 'background-color: white;'}
    ${({ box }) => box === PlanSelection.MONTHLY
    ? 'border-bottom-left-radius: 15px; border-bottom-right-radius: 15px;'
    : 'border-bottom-left-radius: 0px; border-bottom-right-radius: 0px;'}  
    cursor: pointer;
  `,
  PriceInfo: styled.div`
    display: flex;
    flex-direction: column;
    width: 150px;
  `,
  PricePerMonth: styled.span<{ checked: boolean }>`
    font-size: smaller;
    text-transform: none;
    ${({ checked }) => checked ? 'font-weight: bold;' : 'font-weight: 400;'}
  `,
  Description: styled.span`
    font-size: x-small;
    text-transform: none;
  `,
  RadioButton: styled.div`
    display: flex;
    font-size: 14px;
  `,
  Input: styled.input`
    accent-color: #2C7AC2;
  `,
  SelectLabel: styled.span<{ checked: boolean }>`
    text-transform: none;
    padding-left: 10px;
    ${({ checked }) => checked
    ? 'font-weight: bold; color: #2C7AC2' : 'font-weight: 400; color: black;'}
  `
}
